<template>
  <div class="underLogoPhrase">
    <h2 class="font-weight-bold mb-4 centers">Qui sommes-nous</h2>
  </div>

  <div class="container" style="margin-top: 20px;">

    <div class="video-wrapper">
      <iframe
        src="https://www.youtube.com/embed/VXhLDZSjLtk"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen>
      </iframe>
    </div>

    <p v-html="formattedPresentation"></p>

  </div>
</template>

<style>
.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
</style>

<script>
export default {
  data() {
    return {
 informations: {}
    };
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          console.log(data);
          
          this.informations = data[0];
        }
      })
      .catch(error => {
        console.error('Erreur getInformations:', error.message);
      });
  },

  computed: {
    formattedPresentation() {
      if (this.informations && this.informations.presentation) {
        let decoded = this.decodeHtml(this.informations.presentation);

        decoded = decoded
          .replace(/<br\s*\/?>/gi, '')
          .replace(/&nbsp;/gi, ' ')
          .trim();

        // Gestion iframe vidéo
        const iframeMatch = decoded.match(/src="([^"]+)"[^>]*title="([^"]*)"/i);

        if (iframeMatch) {
          const src = iframeMatch[1];
          const title = iframeMatch[2] || 'Vidéo';

          return `
            <div class="ratio ratio-16x9">
              <iframe src="${src}" title="${title}" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
              </iframe>
            </div>
          `;
        }

        return decoded.replace(/\r?\n/g, '<br>');
      }

      return '';
    }
  },

  methods: {
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }
};
</script>

<style src="../assets/css/besoins.css"></style>
